export default __webpack_public_path__ + "images/service_it-support.jpg";